var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLukeHead(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "82px",
    viewBox: "0 0 80 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/head_landing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile/tablet-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing---Login-Cargill-Copy-2",
    transform: "translate(-787.000000, -156.000000)",
    stroke: "#5f00a0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(788.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "head_landing"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3140862,62.7098323 L53.3140862,51.6153549 C58.05221,46.0117315 59.3683649,40.6986118 59.3683649,34.5659879 C59.3683649,24.7226554 52.5244273,17.2452039 40.1525364,17.2452039 C27.7806456,17.2452039 22.2528629,26.6080407 22.2528629,33.7069092 L22.2528629,39.3252417 C22.2528629,40.6511576 22.190481,40.6551851 21.9784509,40.9961199 C20.9544339,42.6433586 19.1146804,44.8169712 18.5675608,45.6923349 C17.7779019,46.9560876 15.7049834,48.5133209 17.3829872,50.0910418 C17.6135956,50.3078252 19.9989347,50.7485715 20.316639,50.7940995 C21.269752,50.9303333 22.121111,51.4374454 22.121111,53.3135499 L22.121111,57.8434125 C22.121111,58.8585122 23.2496091,62.4554007 26.5399965,61.8469012 C29.830384,61.2384018 40.1525364,59.6013193 41.7978154,59.1280031 C43.4429239,58.6546868 45.4171563,57.0321383 45.4171563,54.7333236 L45.4171563,44.9152067",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7570361,36.8420265 C51.7570361,40.7381531 48.6900701,43.8968826 44.9067569,43.8968826 C41.1234436,43.8968826 38.0566442,40.7381531 38.0566442,36.8420265 C38.0566442,32.9457282 41.1234436,29.7871703 44.9067569,29.7871703 C48.6900701,29.7871703 51.7570361,32.9457282 51.7570361,36.8420265 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6355542,39.9775181 C77.6355542,62.0565541 60.256304,79.9550361 38.8177771,79.9550361 C17.3792502,79.9550361 0,62.0565541 0,39.9775181 C0,17.8984821 17.3792502,0 38.8177771,0 C60.256304,0 77.6355542,17.8984821 77.6355542,39.9775181 Z",
    id: "Stroke-5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLukeHead);
export default __webpack_public_path__ + "static/media/luke_head.81e2f98ad40e1c6ca5e8e7efaa96d5ab.svg";
export { ForwardRef as ReactComponent };